import { gql } from "@apollo/client";
import { BUSINESS_BOOKING_TYPE_FIELDS } from "./bookingType";

export const PLANS_FIELDS_FRAGMENT = `
  id
  code
  name
  description
  features
  capabilities
  isActive
`;

export const BUSINESS_FIELDS_FRAGMENT = `
  id
  workspaceType
  name
  displayOnBookingPage
  description
  businessCategoryId
  businessSubcategoryId
  businessTopCategory {
    id
    name
    slug
    parentCategoryId
  }
  businessSubcategory {
    id
    name
    slug
    parentCategoryId
  }
  images {
    id
    url
    businessId
    staffId
  }
  status
  currency
  street
  countryId
  stateId
  cityId
  address
  cityName
  stateName
  stateCode
  zipcode
  stage
  createdBy
  claimStatus
  exemptedPlanId
  exemptedPlanExpiresAt
  roles {
    id
    name
    description
    permissions
  }
  plans {
    ${PLANS_FIELDS_FRAGMENT}
  }
  phoneNumbers {
    countryCode
    phoneNumber
  }
  faxNumber
  emails
  url
  links {
    platform
    url
  }
  workingHourGroups {
    id
    title
    def
    custom
    isForBusiness
    timeZone {
    id
    timezone
    }
    workingHours {
      id
      groupId
      day
      onJob
      startTime
      endTime
      parentId
    }
  }
  businessBookingTypes {
      ${BUSINESS_BOOKING_TYPE_FIELDS}
    }
  staffs {
    status
    id
    initials
    url
    showGoogleEvents
    image {
      id
      url
      staffId
    }
    subscription
    {
      id
      planId
    }
    workingHourGroups {
      id
      title
      def
      custom
      isForBusiness
      timeZone {
          id
          timezone
        }
      workingHours {
        id
        groupId
        day
        onJob
        startTime
        endTime
        parentId
      }
      workingHourOverrideGroups {
        id
        groupId
        startDate
        endDate
        title
        workingHourOverrides {
          id
          whOverrideGroupId
          startTime
          endTime
        }
      }

    }
    user {
      id
      email
      username
      phone
      isAgent
      isDefaultConcierge
      isPlatformAdmin
       timeZone {
        id,
        timezone
        }
    }
    role
    {
      id
      name
      permissions
    }
  }
`;

// Define the query using the fragment
export const GET_MY_BUSINESSES = gql`
  query MyBusinesses {
    myBusinesses {
      ${BUSINESS_FIELDS_FRAGMENT}
    }
  }
`;

// You can define another query with a different name using the same fragment
export const GET_BUSINESSES = gql`
query GetBusinesses($countryId: ID) {
  businesses(countryId: $countryId) {
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`;

export const GET_BUSINESS_AND_RELATED_BY_ID = gql`
query GetBusinessById($id: ID, $staffUrl: String) {
  business(id: $id, staffUrl: $staffUrl) {
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`;

export const GET_BUSINESS_BY_URL = gql`
query GetBusinessByUrl($businessUrl: String, $staffUrl: String) {
  businessByUrl(businessUrl: $businessUrl, staffUrl: $staffUrl) {
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`;

export const PUBLIC_BOOKING_TYPE_SUMMARY_FIELDS_FRAGMENT = `
  id
  title
  link
  length
  price
  color
  isPublic
  displayOnBookingPage
  bookingTypeCategoryId
`;

export const PUBLIC_BOOKING_BUSINESS_FIELDS_FRAGMENT = `
  id
  name
  workspaceType
  description
  address
  businessCategoryId
  url
  images {
    id
    url
    businessId
  }
  phoneNumbers {
    countryCode
    phoneNumber
  }
  emails
  links {
    platform
    url
  }
  workingHourGroups {
    id
    title
    def
    custom
    isForBusiness
    timeZone {
      id
      timezone
    }
    workingHours {
      id
      groupId
      day
      onJob
      startTime
      endTime
      parentId
    }
  }
  businessBookingTypes {
    ${PUBLIC_BOOKING_TYPE_SUMMARY_FIELDS_FRAGMENT}
  }
`;

export const GET_PUBLIC_BOOKING_BUSINESS_BY_URL = gql`
query GetPublicBookingBusinessByUrl($businessUrl: String!) {
  businessByUrl(businessUrl: $businessUrl) {
    ${PUBLIC_BOOKING_BUSINESS_FIELDS_FRAGMENT}
  }
}
`;

// Define the enum for query names
export enum BusinessQueryNames {
  GET_MY_BUSINESSES = "GET_MY_BUSINESSES",
  GET_BUSINESSES = "GET_BUSINESSES",
}

export const BUSINESS_STATES = gql`
  query BusinessStates($countryId: Int!) {
    businessStates(countryId: $countryId) {
      stateCode
      stateName
    }
  }
`;

// CITY_COUNTS
export const BUSINESS_CITIES = gql`
  query businessCities($countryId: Int!, $stateCode: String!) {
    businessCities(countryId: $countryId, stateCode: $stateCode) {
      cityId
      cityName
    }
  }
`;

// BUSINESSES_PAGED
export const BUSINESSES_PAGED = gql`
  query BusinessesPaged(
    $countryId: Int
    $stateCode: String
    $cityId: Int
    $search: String
    $limit: Int
    $offset: Int
    $advZip: String
    $radiusMiles: Int
    $claimed: String
  ) {
    businessesPaged(
      countryId: $countryId
      stateCode: $stateCode
      cityId: $cityId
      search: $search
      limit: $limit
      offset: $offset
      advZip: $advZip
      radiusMiles: $radiusMiles
      claimed: $claimed
    ) {
      total
      items {
        id
        name
        description
        businessCategoryId
        businessSubcategoryId
        status
        cityId
        cityName
        stateCode
        street
        address
        zipcode
        url
        displayOnBookingPage
        emails
        phoneNumbers {
          countryCode
          phoneNumber
        }
        images {
          id
          url
        }
        claimStatus
        businessTopCategory {
          id
          name
          slug
          parentCategoryId
        }
        businessSubcategory {
          id
          name
          slug
          parentCategoryId
          parentCategory {
            id
            name
            slug
            parentCategoryId
          }
        }
        businessBookingTypes {
          ${BUSINESS_BOOKING_TYPE_FIELDS}
        }
      }
    }
  }
`;
